export const presets = [
    {
        type: 'm',
        values: {
            main_content_height: '450px',
            main_content_width: '100%',
            main_content_left: '0',
            logo_width: "110px",
            logo_wrapper_width: "100%",
            logo_wrapper_height: "50%",
            logo_wrapper_justify_content: "center",
            top_nav_height: "80px",
            top_nav_width: "100%",
            single_select_width: '85%',
            notification_left_pos: "10%"

        }
    },
    {
        type: 't',
        values: {     
            main_content_height: '600px',
            main_content_width: '60%',
            main_content_left: '15%',
            logo_width: "120px", 
            logo_wrapper_width: "55%", 
            logo_wrapper_height: "100%",  
            logo_wrapper_justify_content: "flex-end",   
            top_nav_height: "80px",
            top_nav_width: "100%",
            single_select_width: '80%',
            notification_left_pos: "10%"
        }
    },
    {
        type: 'd',
        values: {
            main_content_height: '600px',
            main_content_width: '50%',
            main_content_left: '23%',
            logo_width: "125px",
            logo_wrapper_width: "52%",
            logo_wrapper_height: "100%",
            logo_wrapper_justify_content: "flex-end",
            top_nav_height: "80px",
            top_nav_width: "100%",
            single_select_width: '60%',
            notification_left_pos: "10%"
        }
    },
];
